import urls from '@/networkRequests/apiClient/endpoints'

import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetAllFulfillmentOrdersForAdminErrorResponse,
  GetAllFulfillmentOrdersForAdminRequest,
  GetAllFulfillmentOrdersForAdminSuccessResponse
} from './getAllFulfillmentOrdersForAdmin.types'

export const getAllFulfillmentOrdersForAdminApi = async (
  request: GetAllFulfillmentOrdersForAdminRequest
): Promise<GetAllFulfillmentOrdersForAdminSuccessResponse> => {
  const { page, size, searchQuery } = request

  const response = await configureRequest({
    url: urls.admin.getAllFulfillmentOrdersForAdmin,
    method: 'GET',
    params: {
      page,
      size,
      ...(searchQuery ? { searchQuery } : {})
    },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetAllFulfillmentOrdersForAdminSuccessResponse
  } else {
    throw response as GetAllFulfillmentOrdersForAdminErrorResponse
  }
}

export default getAllFulfillmentOrdersForAdminApi
